import React from 'react';

const PaymentCardSkeleton = ({ count = 6 }) => {
  return (
    <div className="container mx-auto">
      <div className="h-8 w-48 bg-gray-200 rounded-md mb-6 animate-pulse"></div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array(count).fill().map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden ">
            {/* Header */}
            <div className="bg-gray-200 h-16 animate-pulse"></div>
            
            <div className="p-4">
              {/* Image placeholder */}
              <div className="w-full h-48 bg-gray-200 rounded-lg mb-4 animate-pulse"></div>
              
              {/* Title and subtitle */}
              <div className="mb-4">
                <div className="h-6 bg-gray-200 rounded-md mb-2 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded-md w-1/2 animate-pulse"></div>
              </div>
              
              {/* Student and contact info */}
              <div className="grid grid-cols-2 gap-2 mb-4">
                <div>
                  <div className="h-4 bg-gray-200 rounded-md w-2/3 mb-2 animate-pulse"></div>
                  <div className="h-5 bg-gray-200 rounded-md w-4/5 animate-pulse"></div>
                </div>
                <div>
                  <div className="h-4 bg-gray-200 rounded-md w-2/3 mb-2 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded-md w-4/5 mb-1 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded-md w-4/5 animate-pulse"></div>
                </div>
              </div>
              
              {/* Amount and date */}
              <div className="grid grid-cols-2 gap-2 mb-4">
                <div>
                  <div className="h-4 bg-gray-200 rounded-md w-2/3 mb-2 animate-pulse"></div>
                  <div className="h-6 bg-gray-200 rounded-md w-3/4 animate-pulse"></div>
                </div>
                <div>
                  <div className="h-4 bg-gray-200 rounded-md w-2/3 mb-2 animate-pulse"></div>
                  <div className="h-5 bg-gray-200 rounded-md w-4/5 animate-pulse"></div>
                </div>
              </div>
              
              {/* Status and button */}
              <div className="flex justify-between items-center">
                <div className="h-6 bg-gray-200 rounded-md w-16 animate-pulse"></div>
                <div className="h-6 bg-gray-200 rounded-md w-20 animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Pagination skeleton */}
      <div className="flex justify-between items-center mt-8">
        <div className="h-4 bg-gray-200 rounded-md w-40 animate-pulse"></div>
        <div className="flex space-x-2">
          <div className="h-10 w-20 bg-gray-200 rounded-md animate-pulse"></div>
          <div className="h-10 w-20 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCardSkeleton;